/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { ChangeRequestUserContributor, EntityId, List } from "./data-contracts";

/**
 * @description Returns a list of users who have contributed content edits to the change request. Use this to identify who has been actively editing the draft, for example when deciding who to notify before merging.
 * @tags change-request-contributors
 * @name GetContributorsByChangeRequestId
 * @summary List all users who have made edits to a change request
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/contributors
 * @secure
 */

// @ts-ignore
export const getContributorsByChangeRequestId: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: ChangeRequestUserContributor[];
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/contributors",
  method: "get",
  streaming: false,
  tags: ["change-request-contributors"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
